import { render, staticRenderFns } from "./TestimonialsSection.vue?vue&type=template&id=557add0e&scoped=true&"
import script from "./TestimonialsSection.vue?vue&type=script&lang=ts&"
export * from "./TestimonialsSection.vue?vue&type=script&lang=ts&"
import style0 from "./TestimonialsSection.vue?vue&type=style&index=0&id=557add0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557add0e",
  null
  
)

export default component.exports